import { SetContextLink } from "@apollo/client/link/context";
import { AuthRoutes } from "../auth/AuthRoutes";
import {
  AuthRefreshUnavailableError,
  AuthSession,
  AuthSessionExpiredError,
  AuthSessionState,
} from "../auth/oauth/AuthSession";

interface AuthSessionClient {
  getSession(): Promise<AuthSession>;
}

let isRedirectingToLogin = false;
export const redirectExpiredSessionToLogin = () => {
  if (
    isRedirectingToLogin ||
    window.location.pathname.startsWith(AuthRoutes.BASEPATH)
  ) {
    return;
  }
  isRedirectingToLogin = true;
  window.location.replace(AuthRoutes.BASEPATH);
};

export const makeAuthLink = (
  authClient: AuthSessionClient,
  onExpiredSession = redirectExpiredSessionToLogin,
) =>
  new SetContextLink(async (prevContext) => {
    const session = await authClient.getSession();
    if (session.state === AuthSessionState.EXPIRED) {
      onExpiredSession();
      throw new AuthSessionExpiredError();
    }
    if (session.state === AuthSessionState.REFRESH_UNAVAILABLE) {
      throw new AuthRefreshUnavailableError();
    }

    const token =
      session.state === AuthSessionState.AUTHENTICATED
        ? session.accessToken
        : null;

    return {
      headers: {
        ...prevContext.headers,
        "x-timezone": Intl.DateTimeFormat().resolvedOptions().timeZone,
        family: "portal",
        authorization: token ? `Bearer ${token}` : "",
      },
    };
  });
